// inicia un js que se encarga de manejar el menu del gestor

export default {
    name: 'menuGestor',
    data() {
        return {
            menu: [
                {
                    // gestion de usuarios
                    title: 'Gestión de usuarios',
                    icon: 'mdi-account-group',
                    path: '/gestor/gestion_usuarios',
                },
                //  suscripcion de usuarios
                {
                    title: 'Adición de usuarios',
                    icon: 'mdi-account-multiple-plus',
                    path: '/suscripcion_extraordinaria',
                },
                // seguimiento de declaraciones
                {
                    title: 'Seguimiento de declaraciones',
                    icon: 'mdi-file-document',
                    path: '/gestor/seguimiento_declaracion',
                },
                {
                    title: 'Otros Servicios',
                    icon: 'workspaces',
                    path: '/servicios_extras',
                }
            ],
        };
    },

    methods: {
        redirigirPagina(path) {
            this.$router.push({ path: path });
        }
    },
};
